{
  "currencies": {
    "title": "Currencies",
    "add": "Add Currency",
    "columns": {
      "nameAr": "Arabic Name",
      "nameEn": "English Name",
      "code": "Currency Code",
      "status": "Status"
    },
    "rowActions": {
      "trigger": "Actions for {{name}}"
    },
    "drawer": {
      "createTitle": "Add Currency",
      "editTitle": "Edit Currency",
      "createDescription": "Add a new currency to use for deposits.",
      "editDescription": "Update this currency's information.",
      "fields": {
        "nameAr": "Arabic Name",
        "nameEn": "English Name",
        "code": "Currency Code",
        "status": "Status"
      },
      "codeHint": "For example: JOD or USD",
      "inUseNotice": "The code cannot change once this currency is used in a deposit",
      "created": "Currency created successfully",
      "updated": "Currency updated successfully"
    },
    "statusConfirmTitle": "Change the status of {{name}}?",
    "statusChanged": "Currency status changed successfully"
  },
  "settings": {
    "title": "Deposit Settings",
    "description": "The text shown on the deposit receipt and the tablet.",
    "fields": {
      "organisationNameAr": "Organisation Name (Arabic)",
      "organisationNameEn": "Organisation Name (English)",
      "receiptHeaderAr": "Receipt Header (Arabic)",
      "receiptHeaderEn": "Receipt Header (English)",
      "depositDeclarationAr": "Deposit Declaration (Arabic)",
      "depositDeclarationEn": "Deposit Declaration (English)",
      "deliveryAcknowledgementAr": "Delivery Acknowledgement (Arabic)",
      "deliveryAcknowledgementEn": "Delivery Acknowledgement (English)",
      "receiptFooterAr": "Receipt Footer (Arabic)",
      "receiptFooterEn": "Receipt Footer (English)"
    },
    "readOnlyNotice": "You do not have permission to edit these settings",
    "saved": "Settings saved successfully",
    "discardTitle": "Discard changes?",
    "discardDescription": "Your unsaved changes will be lost.",
    "unsavedChanges": "You have unsaved changes",
    "phoneVerification": "Verify the phone number with a WhatsApp code",
    "phoneVerificationHelp": "A code is sent by WhatsApp when a customer is added or a phone is changed. The record is saved only after the code is entered."
  }
}
